import Button from '@/common/components/Button'
import { formatCurrency, formatDateTime } from '@/common/utils/formatters'
import { tmaisNfcesStatusStrategy } from '@/features/tmaisNfces/constants/statusOptions.constant'
import { TmaisNfceData } from '@/features/tmaisNfces/types/tmaisNfces.type'
import { ArrowBigRight } from 'lucide-react'
import { Link } from 'react-router-dom'

export class TmaisNfcesTransformer {
  static tableTransformer() {
    return (tmaisNfces: TmaisNfceData[]) => {
      return tmaisNfces.map((nfce) => {
        return {
          ...nfce,
          status: nfce.status ? tmaisNfcesStatusStrategy[nfce.status as keyof typeof tmaisNfcesStatusStrategy] : '',
          uploaded_by_name: nfce.uploaded_by?.full_name ?? '',
          establishment: nfce.establishment_company_branch?.general_information?.fantasy_name ?? 'Taurus (Global)',
          total_amount: nfce.total_amount ? formatCurrency(Number(nfce.total_amount)) : '',
          created_at: nfce.created_at ? formatDateTime(new Date(nfce.created_at)) : '',
          actions: (
            <Link to={nfce.id}>
              <Button
                name="access_tmais_nfce_button"
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Admin::Tmais::Nfces::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
